import axios from "axios";
import { api, headers } from "../../app/conf";
import { makeQuery } from "../../shared/helpers/commons";
import React from "react";
import { toast } from 'react-toastify';
import SVG from 'react-inlinesvg';
import { errorCircleSVG } from '../../shared/helpers/icons';
import styles from '../../shared/styles/notifications.module.scss';

export const getVehicles = (filters, token) =>
    axios({
        method: "get",
        url: `${api}/vehicles?${makeQuery(filters)}`,
        headers: {
            ...headers,
            "X-Access-Token": token
        }
    });

    export const getVehicleAudit = (vehicleId, token) =>
        axios({
          method: "get",
          url: `${api}/vehicles/${vehicleId}/audits`,
          headers: {
            ...headers,
            "X-Access-Token": token
          },
        });      

export const getVehicleTickets = (vehicleId, token) =>
    axios({
        method: "get",
        url: `${api}/vehicles/${vehicleId}/tickets`,
        headers: {
            ...headers,
                "X-Access-Token": token
              },
            });      

export const patchVehicle = (vehicleId, data, token) =>
    axios({
      method: "patch",
      url: `${api}/vehicles/${vehicleId}`,
      headers: {
        ...headers,
        "X-Access-Token": token,
        "Content-Type": "application/json"
      },
      data
    });

export const assignVehicleAgent = (vehicleId, agentId, token) =>
    axios({
      method: "post",
      url: `${api}/vehicles/${vehicleId}/agent/${agentId}`,
      headers: {
        ...headers,
        "X-Access-Token": token
      }
    });

export const addVehicleComment = (vehicleId, comments, token) =>
    axios({
      method: "post",
      url: `${api}/vehicles/${vehicleId}/comments`,
      headers: {
        ...headers,
        "X-Access-Token": token
      },
      data: { comments }
    });

export const uploadVehicleImage = (file, token) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('ts', Date.now().toString());
    
    return axios({
        method: "post",
        url: `${api}/files/uploads`,
        headers: {
            ...headers,
            "X-Access-Token": token,
            "Content-Type": "multipart/form-data"
        },
        data: formData
    }).catch(error => {
        // Handle error and show toast
        const errorMessage = error?.response?.data?.error || error?.message || 'Error al subir la imagen';
        
        const message = errorMessage === 'File too large' 
            ? 'La imagen excede el tamaño máximo permitido.'
            : 'Error al subir la imagen. Por favor, intente nuevamente.';
        
        toast.error(
            <div className={styles.customToastError}>
                <div className={styles.toastContent}>
                    <SVG src={errorCircleSVG} className={styles.toastIconError} />
                    {message}
                </div>
            </div>,
            {
                className: styles.toast,
                toastId: `upload-error-${Date.now()}`
            }
        );
        
        // Re-throw error so component can handle it
        const formattedError = new Error(errorMessage);
        formattedError.response = error.response;
        formattedError.originalError = error;
        throw formattedError;
    });
};